module.exports = __webpack_public_path__ + "img/bd.a75fe1c6.svg";